import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) Alimentícia",
    correct: true,
  },
  {
    option: "b) Mineração",
    correct: false,
  },
  {
    option: "c) Siderurgia",
    correct: false,
  },
  {
    option: "d) Açúcar e álcool",
    correct: false,
  },
  {
    option: "e) Papel e celulose",
    correct: false,
  },
];

export default function Question18(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question18: {
          title:
            "Quais dos segmentos abaixo não é um potencial cliente para o SAI Smart Loop?",
          option: option.option,
          correct: option.correct,
          order: 18,
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t(
          "Quais dos segmentos abaixo não é um potencial cliente para o SAI Smart Loop?"
        )}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
